import { TagIcon, ClockIcon, BoltIcon, MapPinIcon, ServerStackIcon, XMarkIcon, BarsArrowUpIcon, BarsArrowDownIcon } from '@heroicons/vue/24/solid';

export const AVAILABLE_EVENT_DISPLAY_SETTINGS = {
	group_by: [
		{ id: 'event_type', label: 'Event Type', icon: TagIcon },
		{ id: 'event_time', label: 'Event Time', icon: ClockIcon },
		{ id: 'channel', label: 'Channel', icon: BoltIcon },
		{ id: 'event_description', label: 'Event Description', icon: null },
		{ id: 'position', label: 'Position', icon: MapPinIcon },
		{ id: 'dmx_universe', label: 'DMX Universe', icon: ServerStackIcon },
		{ id: 'module_type', label: 'Module', icon: XMarkIcon },
		{ id: 'no_grouping', label: 'No Grouping', icon: XMarkIcon },
	],
	order_by: [
		{ id: 'event_time', label: 'Event Time', icon: ClockIcon },
		{ id: 'dmx_universe', label: 'DMX Universe', icon: ServerStackIcon },
		{ id: 'channel', label: 'Channel', icon: BoltIcon },
		{ id: 'event_description', label: 'Event Description', icon: null },
		{ id: 'position', label: 'Position', icon: MapPinIcon },
		{ id: 'no_ordering', label: 'No Sorting', icon: XMarkIcon },
	],
	order_direction: [
		{ id: 'asc', label: 'Ascending', icon: BarsArrowUpIcon },
		{ id: 'desc', label: 'Descending', icon: BarsArrowDownIcon },
	],
	fields_to_display: [
		{ id: 'row_number', label: 'Row Number' },
		{ id: 'event_type', label: 'Event Type' },
		{ id: 'event_time', label: 'Event Time' },
		{ id: 'dmx_universe', label: 'DMX Universe' },
		{ id: 'channel', label: 'Channel' },
		{ id: 'cue', label: 'Cue' },
		{ id: 'event_description', label: 'Event Description' },
		{ id: 'position', label: 'Position' },
		{ id: 'category', label: 'Event Category' },
		{ id: 'duration', label: 'Duration' },
		{ id: 'pre_fire', label: 'Pre Fire' },
		{ id: 'lift_time', label: 'Lift Time' },
		{ id: 'pulse_time', label: 'Pulse Time' },
		{ id: 'custom_columns', label: 'Custom Columns' },
		{ id: 'disable_group', label: 'Disable Group' },
	],
};

export const DEFAULT_EVENT_DISPLAY_SETTINGS = {
	group_by: 'no_grouping',
	order_by: 'event_time',
	order_direction: 'asc',
	show_empty_groups: false,
	fields_to_display: ['row_number', 'event_type', 'event_time', 'dmx_universe', 'channel', 'cue', 'event_description', 'position', 'duration', 'disable_group'],
	auto_scroll_rows: true,
};
